import { pxToRem, responsiveFontSizes } from "utils/getFontValue";

// ----------------------------------------------------------------------

const FONT_PRIMARY =
	"var(--pretendard-regular), var(--noto-sans)";
const FONT_SECONDARY =
	"var(--pretendard-regular), var(--noto-sans)";
const FONT_BOLD = "var(--pretendard-bold)";

const typography = {
	fontFamily: FONT_SECONDARY,
	lineHeight: 1.2,
	h1: {
		fontFamily: FONT_PRIMARY,
		fontSize: pxToRem(32),
		fontWeight: 700,
	},
	h2: {
		fontFamily: FONT_PRIMARY,

		fontSize: pxToRem(30),
		fontWeight: 700,
	},
	h3: {
		fontFamily: FONT_PRIMARY,
		fontSize: pxToRem(28),
		fontWeight: 700,
	},
	h4: {
		fontFamily: FONT_PRIMARY,
		fontSize: pxToRem(26),
		fontWeight: 700,
	},
	h5: {
		fontFamily: FONT_PRIMARY,
		fontSize: pxToRem(22),
		fontWeight: 700,
	},
	h6: {
		fontFamily: FONT_PRIMARY,
		fontSize: pxToRem(20),
		fontWeight: 400,
	},
	subtitle1: {
		fontFamily: FONT_PRIMARY,
    fontSize: pxToRem(20),
		fontWeight: 400,
	},
	subtitle2: {
    fontSize: pxToRem(20),
		fontWeight: 400,
	},
	body1: {
		fontFamily: FONT_PRIMARY,
    fontSize: pxToRem(18),
		fontWeight: 400,
	},
	body2: {
		fontSize: pxToRem(18),
		fontWeight: 400,
	},
	body3: {
		fontFamily: FONT_PRIMARY,
    fontSize: pxToRem(16),
		fontWeight: 400,
	},
	caption: {
    fontSize: pxToRem(16),
		fontWeight: 400,
	},
};

export default typography;
